import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/main.css";
import Axios from "axios";
import VIcon from "vue-tailwind-icons";
import VCalendar from "v-calendar";

import ActionsItem from "@/components/elements/ActionsItem.vue";
import ActionsMenu from "@/components/elements/ActionsMenu.vue";
import BaseCheckbox from "@/components/elements/BaseCheckbox.vue";
import HttpError from "@/components/elements/HttpError.vue";
import iconFgt from "@/components/elements/IconFgt.vue";
import LoadingSpinner from "@/components/elements/LoadingSpinner.vue";
import AlertSuccess from "@/components/elements/AlertSuccess.vue";
import Alert from "@/components/elements/Alert.vue";

Vue.use(VIcon);
Vue.use(VCalendar);

Vue.component("ActionsItem", ActionsItem);
Vue.component("ActionsMenu", ActionsMenu);
Vue.component("BaseCheckbox", BaseCheckbox);
Vue.component("HttpError", HttpError);
Vue.component("icon-fgt", iconFgt);
Vue.component("LoadingSpinner", LoadingSpinner);
Vue.component("AlertSuccess", AlertSuccess);
Vue.component("Alert", Alert);

Vue.config.productionTip = false;
Vue.prototype.$axios = Axios;
// Vue.prototype.$axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// Vue.prototype.$axios.defaults.withCredentials = true;
// Vue.prototype.$axios.defaults.baseURL = "http://merchandising.local/";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
